import { QuestionConfigurator } from './question';
import { CommentView } from '../view';
import { CommentValidator } from '../validator';

export class CommentConfigurator extends QuestionConfigurator {
  get view() {
    return CommentView;
  }

  initValidator() {
    this.validator = new CommentValidator();
  }

  getDefaultData(): Object {
    return {
      input: undefined,
      ...this.data,
    };
  }

  isComment() {
    return true;
  }

  getFeedbackData(answers: any): any {
    const data = answers[this.key];
    const { input } = data;
    return {
      key: this.key,
      type: 'comment',
      title: this.getTitle(answers),
      answer: input,
    };
  }
}
